// NOTE: This implementation should be slightly faster than the one from `ramda-extension`.
export const getIsPlainObject = (value: unknown): value is object =>
	value != null && typeof value === 'object' && Array.isArray(value) === false;
